import TruckScaleLanding from './TruckScaleLanding'

export default TruckScaleLanding
